import type { FaireProductEntity } from "../../entity_types/product";

export const p_fbjzqug4mk: FaireProductEntity = {
  token: "p_fbjzqug4mk",
  type: "product",
  name: "Smudge Sticks Palo Santo Scented Incense Sticks",
  brandToken: "b_23nx3nnsvm",
  brandName: "Pacific Trading",
  imageUrl:
    "https://cdn.faire.com/fastly/76c420f25d3e3bd139fe0ba4d610d76ed7126f6e8a141c3295b5ab42592f0db8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/400f12c6e9a787a8cc4694b3323e30cd2e1c673e562b82f628121d0688bca654.jpeg",
    "https://cdn.faire.com/fastly/0c865455f8c04d72293d6ca81a2a0965c955a361960601a7bc6266676c8b980c.jpeg",
  ],
  priceDollars: 5.54,
  description:
    'A unique blend of smudge herbs with incense.\nFragrance: Palo Santo\n16 sticks per box\n\nPremium incense rolled with smudge herbs on bamboo sticks.\nApprox. 5 mm thick; 9" long.\nPure & Natural; Ethically sourced ingredients: Uplifts mind & spirit',
  tags: [],
  msrpDollars: 11.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:53.815Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
